import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dccs-detail',
  templateUrl: './dccs-detail.component.html',
  styleUrls: ['./dccs-detail.component.scss']
})
export class DccsDetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
